import BaseCrudService from '@/services/base-crud-service'
import customerConfig from '@/config/customer-config'

class CustomerService extends BaseCrudService {
  //
}

export default new CustomerService(customerConfig.API_RESOURCE)
